<template>
  <div class="quick-wrap" v-show="show" @touchmove.prevent>
    <div class="quick-order">
      <div class="icon-close" @click="close">
        <span class="iconfont icon1">&#xe614;</span>
        <span class="iconfont icon2">&#xe606;</span>
      </div>
      <div class="quick-title">{{L.downloadCreditLimit}}</div>
      <div class="remark">{{L.PleaseDownloadCredit}}</div>
      <div class="btn-wrap" @click="downloadPricelist" v-loading="loading">
        <span class="iconfont icon-cart">&#xe61c;</span>
        <span>{{L.download}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {api_download_credit_limit} from '@/api/api'
import {downFilePost} from '@/api/tool'

export default {
  name:'CreditLimit',
  data() {
    return {
      loading:false,
      show:false
    }
  },
  methods:{
    open(){
      this.show=true
    },
    close(){
      this.show=false
    },
    downloadPricelist(){
      this.loading=true
      downFilePost(api_download_credit_limit,{}).then(res=>{
        this.loading=false
        this.downloadFile(res)
      }).catch(()=>{
        this.loading=false
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import url('../../public/css/public.less');
/* 快速下单 */
.quick-wrap{
  position: fixed;
  left:0;
  top:0;
  width:100%;
  height:100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  overflow: hidden;
  .quick-order{
    border-radius: 2px;
    position: absolute;
    // &:extend(.main-box-shadow);
    width:450px;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    padding:40px;
    box-sizing: border-box;
    text-align: left;
    .icon-close{
      // background-color: red;
      position: absolute;
      right:14px;
      top:14px;
      .icon1{
        font-size: 24px;
        display: block;
        color:#888;
      }
      .icon2{
        font-size: 24px;
        display: none;
        color:@mainColor;
      }
      &:hover{
        cursor: pointer;
        .icon1{
          display: none;
        }
        .icon2{
          display: block;
        }
      }
    }
    .quick-title{
      font-size: 16px;
      font-weight: 600;
    }
    .remark{
      margin-top: 16px;
    }
    .btn-wrap{
      margin-top: 26px;
      text-align: center;
      width:100%;
      color:#fff;
      background-color: @mainColor;
      padding:8px 6px;
      box-sizing: border-box;
      border:1px solid @mainColor;
      border-radius: 2px;
      &:extend(.transtion-time);
      .icon-cart{
        margin-right: 6px;
      }
      &:hover{
        cursor: pointer;
        color:@mainColor;
        background-color: #fff;
        &:extend(.transtion-time);
      }
    }
  }
}

</style>